<template>
  <div v-if="featureFlags.enableNewTrolleyJourney">
    <TsCarouselV2 v-if="useCarousel" append-class="px-0">
      <TsCarouselSlide v-for="item in items" :key="item.id" append-class="flex-[0_0_auto]">
        <button
          class="flex flex-col items-center gap-3 min-w-[96px] md:min-w-[112px]"
          :data-testid="`${dataTestid}-item-${item.id}`"
          @click="onClick(item)"
        >
          <div
            class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#F5FAFF] border-2 border-white flex items-center justify-center"
          >
            <TsImage
              :src="item.image"
              :alt="item.label"
              class="w-16 h-16 md:w-20 md:h-20 object-contain"
              loading="lazy"
            />
          </div>

          <TsTypography
            as="span"
            align="center"
            class="text-xs md:text-sm w-20 md:w-24 text-center break-words leading-tight"
          >
            {{ item.label }}
          </TsTypography>
        </button>
      </TsCarouselSlide>
    </TsCarouselV2>

    <div v-else class="flex gap-6 flex-wrap">
      <button
        v-for="item in items"
        :key="item.id"
        class="flex flex-col items-center gap-3 min-w-[96px] md:min-w-[112px]"
        :data-testid="`${dataTestid}-item-${item.id}`"
        @click="onClick(item)"
      >
        <div
          class="w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#E6F3FF] border border-natural-light-grey flex items-center justify-center"
        >
          <TsImage
            :src="item.image"
            :alt="item.label"
            class="w-12 h-12 md:w-14 md:h-14 object-contain"
            loading="lazy"
          />
        </div>

        <TsTypography
          as="span"
          align="center"
          class="text-xs md:text-sm w-20 md:w-24 text-center break-words leading-tight"
        >
          {{ item.label }}
        </TsTypography>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const TsCarouselSlide = defineAsyncComponent(
  () => import('~/components/organisms/TsCarouselSlide.vue')
);

const TsCarouselV2 = defineAsyncComponent(() => import('~/components/organisms/TsCarouselV2.vue'));

const config = useRuntimeConfig();
const featureFlags = config.public.featureFlags;

type CategoryItem = {
  id: string | number;
  label: string;
  image: string;
  href?: string;
};

const props = withDefaults(
  defineProps<{
    items: CategoryItem[];
    carouselThreshold?: number;
    dataTestid?: string;
  }>(),
  {
    carouselThreshold: 6,
    dataTestid: 'category-icon-list',
  }
);

const emit = defineEmits<{
  (e: 'item-click', item: CategoryItem): void;
}>();

const useCarousel = computed(() => props.items.length > props.carouselThreshold);

const onClick = (item: CategoryItem) => {
  emit('item-click', item);
  if (item.href) navigateTo(item.href);
};
</script>
